// eslint-disable-next-line no-undef
var baseUrl = process.env.API_URL;
var urlGenerate = function (endpoint, args) {
    var url = new URL("/api/legacy/".concat(endpoint.startsWith('/') ? endpoint.substring(1) : endpoint), baseUrl);
    if (args) {
        for (var _i = 0, args_1 = args; _i < args_1.length; _i++) {
            var _a = args_1[_i], key = _a.key, value = _a.value;
            url.searchParams.set(key, value.toString());
        }
    }
    return url.toString();
};
export default urlGenerate;
